import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useContext, useMemo, useState } from 'react';
import axios from 'axios';
import { CampaignContext } from '../../../../contexts/CampaignContext';
import IResponse from '../../../../interfaces/response';
import CampaginTable from '../../../common/CampaignTable';
import MediaEditModal from './MediaEditModal';

const MediaIndex = () => {
	let { fetchedMedias } = useContext(CampaignContext);
	let { t } = useTranslation();
	const [openModal, setOpenModal] = useState<boolean>(false);
	const [data, setData] = useState<any | null>(null);
	const [id, setId] = useState<number | null>(null);
	const headerClassNames = 'text-xs bg-background-paper';
	const tabItem = useMemo(
		() => [
			{
				api: '/admin/medias',
				postApi: '/admin/medias',
				system_name: '',
				label: 'medias',
				search: '',
				showBtn: false,
				editAction: (id: number) => {
					axios<IResponse<any>>({
						url: `admin/medias/${id}`,
						method: 'get',
					}).then(res => {
						if (res.data.success) {
							setId(id);
							setOpenModal(prev => !prev);
							setData(res.data.data);
						}
					});
				},
				view: false,
				edit: true,
				delete: false,
				columns: [
					{
						field: 'title',
						flex: 1,
						headerName: t('title'),
						headerAlign: 'center',
						align: 'center',
						headerClassName: headerClassNames,
					},
					{
						field: 'count',
						flex: 1,
						headerName: t('count'),
						headerAlign: 'center',
						align: 'center',
						headerClassName: headerClassNames,
						renderCell: (params: any) => {
							let filterMedia = fetchedMedias?.find(item => item.system_name === params.row.media);
							return filterMedia?.title;
						},
					},
				],
				route: 'campaigns/view',
			},
		],
		[setId, setOpenModal, setData, fetchedMedias, t, headerClassNames],
	);

	let handleCreate = () => {
		axios<IResponse<any>>({
			url: `admin/medias/${id}`,
			method: 'post',
			data: { ...data, is_social: data.is_social ? 1 : 0 },
		}).then(res => {
			if (res.data.success) {
				setData(res.data.data);
				setOpenModal(false);
			}
		});
	};
	return (
		<Box className="w-full">
			<MediaEditModal label="medias" handleCreate={handleCreate} isSocial={data && data.is_social} openModal={openModal} data={data} setData={setData} setOpen={setOpenModal} />
			<CampaginTable tabItem={tabItem[0]} setOpenModal={setOpenModal} dataEdit={data} openModal={openModal} />
		</Box>
	);
};

export default MediaIndex;
